// removed by extract-text-webpack-plugin
module.exports = {"root":"bags--root--2tfYBJlp organization-home--root--29mpR9MJ","grid-container":"bags--grid-container--18AGAZia home--grid-container--3c3JLjRI","gridContainer":"bags--grid-container--18AGAZia home--grid-container--3c3JLjRI","form-container":"bags--form-container--3RhUHpz0 home--message--9FSspPIv","formContainer":"bags--form-container--3RhUHpz0 home--message--9FSspPIv","title":"bags--title--2EX46_qR crops--title--3nbOw3vq","modify-form":"bags--modify-form--35wnihy7 undefined","modifyForm":"bags--modify-form--35wnihy7 undefined"};


//////////////////
// WEBPACK FOOTER
// ./views/lado-a-lado/dealer/bags/styles.css
// module id = ./views/lado-a-lado/dealer/bags/styles.css
// module chunks = 0